import { get, isNumber } from 'lodash';
import Cookies from 'universal-cookie';

export const getCookie = (cookiename = "usertoken", parseJson = false, alt = "") => {
    // Get name followed by anything except a semicolon
    var cookiestring = RegExp(cookiename + "=[^;]+").exec(document.cookie);
    // Return everything after the equal sign, or an empty string if the cookie name not found
    cookiestring = decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
    if (parseJson && cookiestring) {
        cookiestring = JSON.parse(cookiestring);
    }
    return cookiestring || alt;
}

export const setCookie = (value, cookiename = "usertoken", remember = true, options = { path: "/", secure: true, sameSite: 'Strict' }) => {
    const cookies = new Cookies();
    if (remember) {
        if (isNumber(remember) === true) {
            options = { ...options, maxAge: remember } // seconds
        } else {
            options = { ...options, maxAge: 86400 } // 1 day
        }
    }
    cookies.set(cookiename, value, options);
}

export const deleteCookie = (cookiename = "usertoken", options = { path: "/", secure: true, sameSite: 'Strict' }) => {
    const cookies = new Cookies();
    cookies.remove(cookiename, options);
}


export const getGameId = () => {
    return '68dcbec9b9a3e08f1e3cd594';
}

export const getCountry = () => {
    return 'uk';
}

export const getLang = () => {
    return getCountry() + ".en";
}

export const openScreenCookieName = "opened";

export const setOpenScreen = (value) => {
    return setCookie(value, openScreenCookieName);
}

export const getOpenScreen = () => {
    return parseInt(getCookie(openScreenCookieName, false, '0'));
}

export const deleteOpenScreen = () => {
    return deleteCookie(openScreenCookieName);
}

export const getGameResultContent = ({ gameOverSection, prizesSection, screen }) => {
    const canTryAgain = true;
    if (screen === "attempts-exceeded") {
        return get(gameOverSection, '2', {}); //  Bad luck out of plays
    }
    if (["round-one-looser"].includes(screen)) {
        if (canTryAgain) {
            return get(gameOverSection, '0', {}); //  Bad luck Try again
        } else {
            return get(gameOverSection, '2', {}); //  Bad luck out of plays
        }
    }
    if (screen === "round-two-looser") {
        if (canTryAgain) {
            return get(prizesSection, 'bronze', {});
        } else {
            return get(gameOverSection, '1', {}); // Bad luck claim prize
        }
    }
    if (screen === "round-three-looser") {
        if (canTryAgain) {
            return get(prizesSection, 'silver', {});
        } else {
            return get(gameOverSection, '1', {}); // Bad luck claim prize
        }
    }
    if (screen === "good-eye") {
        return get(prizesSection, 'gold', {});
    }
    return {};
}

export function isIOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check iOS via userAgent
  const iOSUA = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  // Handle iPads on iOS 13+ which report as Mac
  const isTouchMac = (
    userAgent.includes("Mac") &&
    'ontouchend' in document
  );

  return iOSUA || isTouchMac;
}

export const gamePlayTime = 180; // seconds